import ContactsFooter from './ContactsFooter';

export default ContactsFooter;
